import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/actualplan/pak",
      name: "pak",
      meta: { requiresAuth: true, title: "routes.personalCalendar" },
      component: () => import("./pak.vue")
    },
    {
      path: "/module/actualplan/pak/:employee_id/date/:date",
      name: "pak",
      meta: { requiresAuth: true, title: "routes.personalCalendar" },
      component: () => import("./pak.vue")
    },
    {
      path: "/module/actualplan/type/:viewtype/date/:date",
      name: "actualplan1",
      meta: { requiresAuth: true, title: "routes.actualPlan" },
      component: () => import("./main.vue")
    },

    {
      path: "/module/actualplan",
      name: "actualplan",
      meta: { requiresAuth: true, title: "routes.actualPlan" },
      component: () => import("./main.vue")
    }
  ]
};
